import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Generate initials from a name
 * @param name - The full name (e.g., "John Doe", "Hinzel", "Mary Jane Smith")
 * @returns The initials (e.g., "JD", "H", "MJS")
 */
export function getInitials(name: string | null | undefined): string {
  if (!name || typeof name !== 'string') {
    return 'U'; // Default for unknown user
  }
  
  const words = name.trim().split(/\s+/);
  
  if (words.length === 1) {
    // Single word - take first two characters
    return words[0].substring(0, 2).toUpperCase();
  } else {
    // Multiple words - take first character of each word
    return words.map(word => word.charAt(0)).join('').toUpperCase();
  }
}
